"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSnapshots = void 0;
const listSnapshots = ({ httpClient, }) => ({ page = 1, per_page = 25, resource_type = undefined, }) => {
    const path = '/snapshots';
    const query_params = {
        page,
        per_page,
        resource_type,
    };
    const url = `${path}`;
    return httpClient.get(url, { params: query_params });
};
exports.listSnapshots = listSnapshots;
//# sourceMappingURL=list-snapshots.js.map